import gql from 'graphql-tag'

export const GET_MANAGE_NOTIFICATIONS_QUERY = gql`
  query GetManageNotifications (
    $propertyId: Int
    $skip: Int!
    $take: Int!
  ) {
    getManageNotifications(
      data: {
        propertyId: $propertyId
        pagination: { skip: $skip, take: $take }
      }
    ) {
      total
      hasMore
      items {
        id
        sentAt
        title
        body
        householdsRead
        householdsTotal
        property {
          id
          name
        }
      }
    }
  }
`

export const GET_MANAGE_NOTIFICATION_DETAIL_QUERY = gql`
  query GetManageNotificationDetail ($id: Int!) {
    getManageNotificationDetail(data: { id: $id }) {
      id
      sentAt
      title
      body
      property {
        id
        name
      }
      attachments {
        fileUrl
        mimeType
        size
        order
      }
      rooms {
        roomId
        roomName
        headOfHouseholdName
        readDevices
        totalDevices
        familyMembers {
          familyMemberId
          name
          readAt
        }
      }
    }
  }
`
